<template>
    <div>
        <!-- detail_Basic Info -->
        <table class="create_table">
            <colgroup>
                <col width="150">
                <col width="*">
                <col width="150">
                <col width="*">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{$t('FIELD.COUNTRY.NAME')}}</th>
                    <td colspan="3">
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100" v-model="rhqCd">
                                    <option :value="rhqCd" selected>{{rhqNm}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100" v-model="corpNo">
                                    <option :value="corpNo" selected>{{corpNm}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100" v-model="countryCd">
                                    <option :value="countryCd" selected>{{countryNm}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.EUR.FIRST.APPROVER')}}</th>
                    <td>
                        <fieldset class="ui_fieldset">
                            <label class="serach-wrap w100p"><!-- 길이조절 -->
                                <input type="text" class="text_input" placeholder="First Approver" v-model="aprFrstUserNm" readonly>
                                <a href="JavaScript:" class="in_btn_search" @click="searchUserPop(1)"><i class="ico_input_serach"></i><span class="sr_only">검색 열기</span></a>
                            </label>
                        </fieldset>
                    </td>
                    <th>{{$t('FIELD.EUR.SECOND.APPROVER')}}</th>
                    <td>
                        <fieldset class="ui_fieldset">
                            <label class="serach-wrap w100p"><!-- 길이조절 -->
                                <input type="text" class="text_input" placeholder="Second Approver"  v-model="aprScndUserNm" readonly>
                                <a href="JavaScript:" class="in_btn_search" @click="searchUserPop(2)"><i class="ico_input_serach"></i><span class="sr_only">검색 열기</span></a>
                            </label>
                        </fieldset>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="btn_wrap_full topLine">
            <a href="JavaScript:" class="btn_white" @click="goListBack">{{$t('BUTTON.GLOBAL.LIST')}}</a>
            <div v-if="creationYn == 'Y'" class="btn_right">
                <a href="JavaScript:" class="btn_blue" @click="save">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
import $                from 'jquery';
import qs               from 'query-string';
import Vue              from 'vue';
import api              from '@/service';
import axios            from 'axios';
import store            from '@/vuex/store';
import { EventBus }     from '@/utils/EventBus';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import SearchUserPopup  from '~va/qnaManager/popup/searchUserPop';

export default {
    name: 'EurAdminSetDetail',
    props: {
        params: {},
        pParams: { type: Object, default: {} },
    },
    components: {
//        'skp-breadcrumbs': SKPBreadcrumbs
    },
    computed: {
        ...mapGetters({
            sysParams: 'getParams',
            corpCd   : 'getCorpCd',
            loginNo  : 'getLoginNo',
        }),
    },
    data() {
        return {
            creationYn: '',
            rhqCdList: [],
            corpNoList: [],
            rhqCd: '',
            rhqNm: '',
            corpNo: '',
            corpNm: '',
            countryCd: '',
            countryNm: '',
            aprFrstUser: '',
            aprScndUser: '',
            aprFrstUserNm: '',
            aprScndUserNm: '',
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            return await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
        },
        getParams() {
            let params = {
                  saveMode      : '2'
                , countryCd      : this.countryCd
                , aprFrstUser   : this.aprFrstUser
                , aprScndUser   : this.aprScndUser
            };
            return params;
        },
        async execSave() {
            return axios
                .post(`${SDLUtil.API_URL}/basis/eur/saveSetValueByCountry.skp`, qs.stringify(this.getParams()))
                .then(resp => {
                    if (resp.data.result) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                    } else {
                        SDLUtil.errorAlert('Error occured.');
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        // [Add] 버튼 클릭 시...
        searchUserPop(mode) {
            SDLUtil.show(
                SearchUserPopup, {
                    rtnFunc: (loginNo, loginId, loginNm) => {
                        this.apprFrstUserNo = loginNm;
                        if (mode == 1) {
                            if (loginNo) {
                                this.aprFrstUser   = loginNo;
                                this.aprFrstUserNm = loginId + ' (' + loginNm + ')';
                            } else {
                                this.aprFrstUser   = '';
                                this.aprFrstUserNm = '';
                            }
                        } else if (mode == 2) {
                            if (loginNo) {
                                this.aprScndUser   = loginNo;
                                this.aprScndUserNm = loginId + ' (' + loginNm + ')';
                            } else {
                                this.aprScndUser   = '';
                                this.aprScndUserNm = '';
                            }
                        }
                    }
                },
                { width: '500px', height: 'auto' },
            );
        },
        save() {
            if (!this.aprFrstUser) {
                SDLUtil.alert('MESSAGE.EUR.EMPTY.FIRST.APPROVER');
                return false;
            }
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    this.execSave();
                },
            });

        },
        goListBack() {
            EventBus.$emit('goApproverList', 1);
        },
    },
    mounted() {
        this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
            this.rhqCdList = data;
            this.getCodeComboList(this.rhqCdList[0].code, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
            });
        });

        this.creationYn     = this.sysParams.creationYn;
        this.rhqCd          = this.pParams.RHQ_CD;
        this.rhqNm          = this.pParams.RHQ_NM;
        this.corpNo         = this.pParams.CORP_NO;
        this.corpNm         = this.pParams.CORP_NM;
        this.countryCd      = this.pParams.COUNTRY_CD;
        this.countryNm      = this.pParams.COUNTRY_NM;
        this.aprFrstUser    = this.pParams.APR_FRST_USER;
        this.aprScndUser    = this.pParams.APR_SCND_USER;
        if (this.aprFrstUser) this.aprFrstUserNm  = this.pParams.APR_FRST_USER_ID + ' (' + this.pParams.APR_FRST_USER_NM + ')';
        if (this.aprScndUser) this.aprScndUserNm  = this.pParams.APR_SCND_USER_ID + ' (' + this.pParams.APR_SCND_USER_NM + ')';
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/ApproverByCountryDetail.vue